import Title from '@/components/Title';
import Banner from '@/components/Banner2';
import Function from '@/components/Advantages';
import BrokerCard from '@/components/BrokerCard';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Title,
    Banner,
    Function,
    BrokerCard,
    Appointment2
  },
  data() {
    return {
      bannerUrl: require('@/assets/images/service/vtuber/vtuber-banner.png'),
      bannerTitle: '虚拟人',
      bannerText: '同花顺AI虚拟人运用多模态数字人对话技术，实现与真人用户“面对面”的交互体验。主要面向券商、银行、运营商、政务、媒体等行业，旨在为客户提供智能化数字人解决方案，提升用户体验、提高服务效率、降低企业人力成本，给客户带来更高的价值。',
      adsList: [{
        img: require('@/assets/images/service/vtuber/vtuber-2.5d.png'),
        title: '2.5D数字人',
        desc: '支持2.5D数字人的视频播报，可以自定义文本、动作等信息，并输出视频'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-3d.png'),
        title: '3D数字人',
        desc: '支持3D卡通、写实、动物数字人的驱动，活化模型，可以进行播报、做动作并输出视频、SDK'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-3dscene.png'),
        title: '3D场景',
        desc: '支持制作3D场景，并可以自自定义展厅，进行编辑，定义展馆内容等'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-resource.png'),
        title: '资源库管理',
        desc: '支持人/物/场的资源管理方式，可以对每个最小的资源单位进行管理'
      }],
      cardList: [{
        url: require('@/assets/images/service/vtuber/vtuber-zs.png'),
        text: '浙商汇金谷：在汇金谷APP中加入数字人投资助理，模拟专业的理财经理，为客户提供选/诊股、大盘分析、热点资讯、板块新闻等各类财经服务。'
      }, {
        url: require('@/assets/images/service/vtuber/vtuber-zgyd.png'),
        text: '浙江移动运营商：在浙江移动创新研究院展厅内，摆放数字人大屏，其可以进行运营商业务办理、话费查询、业务退订等，并可以作为大堂经理介绍公司理念、愿景等。'
      }],
      applicationList: [{
        img: require('@/assets/images/service/vtuber/vtuber-app1.png'),
        title: 'AI短视频',
        desc: '可视化视频编辑，实现从业务配置到内容生产、对话服务全流程。文本、语音形式驱动数字人进行播报，唇形、动作由模型计算生成。'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-app2.png'),
        title: '数字人客服',
        desc: '数字人应用于客服体系，代替真人进行客户服务。客户可以借助数字人客服解决业务咨询、业务办理、问题反馈等多类问题。'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-app3.png'),
        title: '虚拟展厅',
        desc: '真实展厅漫游，全仿真展厅环境；支持嵌入式视频播放、点击海报放大展示、伴随讲解、VR交互；支持数字人讲解员可模拟真人进行参观引导、PPT/图片讲解，同时解答客户问题。'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-app4.png'),
        title: '虚拟人大屏',
        desc: '可以作为数字人大堂经理，介绍公司信息，同步各类公司信息。支持化身为数字人员工代替业务人员，进行业务受理工作，数字人员工可以引导客户进行业务办理、解答业务问题、完成身份验证等多项服务。'
      }],
      listItems: [[{
        img: require('@/assets/images/service/vtuber/vtuber-ads1.png'),
        title: '形象定制',
        desc: '3D模型，支持客户各类自由定制，支持脸型、发型、服装、司徽等设计需求'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-ads2.png'),
        title: '表情动作',
        desc: '根据文本内容插入相关的表情肢体动作，过渡自然，提升形象交互的丰富度和灵活性'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-ads3.png'),
        title: '口型驱动',
        desc: '数字人在与人对话时，口型可以与语音内容完美匹配，并做到自然流畅'
      }], [{
        img: require('@/assets/images/service/vtuber/vtuber-ads4.png'),
        title: '语音识别',
        desc: '支持多场景的8K、16K语音识别能够准确识别出说话内容，金融领域识别率可达98%'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-ads5.png'),
        title: '互动识别',
        desc: '支持手势进行交互，打招呼、锤子剪刀布，能处理用户的说话内容，情绪信息'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-ads6.png'),
        title: '人脸识别',
        desc: '秒级别快速识别人脸，支持自定义人脸照片库，轻松识别用户身份与用户情绪'
      }], [{
        img: require('@/assets/images/service/vtuber/vtuber-ads7.png'),
        title: '自然语言理解',
        desc: '能够识别用户的说话意图，并给出数字人的回复内容，解答用户问题并关心用户情绪'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-ads8.png'),
        title: '金融问答',
        desc: '内置庞大金融数据库，覆盖金融标准句2.1W+，支持3W+金融知识的问答'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-ads9.png'),
        title: '语音合成',
        desc: '为形象定制个性化语音合成库，可以根据客户需求模拟员工的声音，提高数字人逼真度'
      }]],
      leftItems: [{
        img: require('@/assets/images/service/vtuber/vtuber-high.png'),
        activeImg: require('@/assets/images/service/vtuber/vtuber-high-active.png'),
        bgImg: require('@/assets/images/service/vtuber/vtuber-left1.png'),
        title: '高质量形象'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-rich.png'),
        activeImg: require('@/assets/images/service/vtuber/vtuber-rich-active.png'),
        bgImg: require('@/assets/images/service/vtuber/vtuber-left2.png'),
        title: '富媒体输入'
      }, {
        img: require('@/assets/images/service/vtuber/vtuber-multi.png'),
        activeImg: require('@/assets/images/service/vtuber/vtuber-multi-active.png'),
        bgImg: require('@/assets/images/service/vtuber/vtuber-left3.png'),
        title: '多模态交互'
      }],
      rightItems: [],
      activeIndex: 0
    };
  },
  methods: {
    changeActive(e, index) {
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;
      this.rightItems = [];
      this.$nextTick(() => {
        this.rightItems = this.listItems[index];
      });
    }
  },
  mounted() {
    this.rightItems = this.listItems[0];
  }
};